import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { Survey } from '../../builders/survey_builder';
import { SurveyQuery } from '../../queries/survey_query';

export class SurveyIntroductionContentController {
  private isUpdatingConsent: boolean = false;
  private surveyNotAvailable: boolean = false;
  private showWelcomeText: boolean = false;
  private showWelcomeBackText: boolean = false;

  constructor(
    private ngSurveyQuery: SurveyQuery,
    private $stateParams: ng.ui.IStateParamsService,
    private $state: ng.ui.IStateService,
    private updateSurveyCommand: ICommand,
    private updateSurveyRecipientTrackingCommand: ICommand,
    private utilityConstant: any
  ) {}

  $onInit() {
    const { surveyID, methodType, recipientID } = this.$stateParams;
    if (!_4.isUndefined(surveyID) && !_4.isUndefined(methodType) && !_4.isUndefined(recipientID)) {
      this.updateSurveyRecipientTrackingCommand(surveyID, methodType, recipientID);
    }
    this.surveyNotAvailable = !_4.isNull(this.survey.unavailable_explanation);
    this.showWelcomeText = !this.survey._is_survey_in_progress && !this.surveyNotAvailable;
    this.showWelcomeBackText = this.survey._is_survey_in_progress && !this.surveyNotAvailable;
  }

  get survey() {
    return _4.find(this.ngSurveyQuery.result, (survey: Survey) => survey.id === this.$stateParams.surveyID);
  }

  exitSurvey() {
    this.$state.go(this.utilityConstant.DEFAULT_ROUTE);
  }

  startSurvey() {
    const surveyID = _4.get(this, 'survey.id');

    if (this.isUpdatingConsent || _4.isUndefined(surveyID)) {
      return;
    }

    this.isUpdatingConsent = true;
    this.updateSurveyCommand(surveyID, { status: 'IN_PROGRESS' })
      .then(() => {
        this.$state.go('my.survey-question', { surveyID });
      })
      .catch(() => (this.isUpdatingConsent = false));
  }
}

export class SurveyIntroductionContentComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-survey/src/components/survey_intro_content/survey_intro_content.html';
  public controller: object = SurveyIntroductionContentController;
  public controllerAs: string = '$ctrl';
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-survey/src/components/survey_intro_content/survey_intro_content.ts